import SectionSeparator from "components/MdxSectionSeparator/sectionSeparator.jsx";
import ecsDataPathImg from "assets/img/docs/gettingStarted/ecs-configurations/datapath.png";
import * as React from 'react';
export default {
  SectionSeparator,
  ecsDataPathImg,
  React
};